import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom/cjs/react-router-dom.min';
import ShipmentByBuyingGroup from './shipmentByBuyingGroup';

const ReportsRouter = () => (
  <Switch>
    <Route
      exact
      path="/sales/report/shipmentbybuyinggroup"
      component={ShipmentByBuyingGroup}
    />
  </Switch>
);

export default ReportsRouter;
